import { createSlice } from "@reduxjs/toolkit";

const planSlice = createSlice({
  name: "plans",
  initialState: {
    plans: [], // Renamed for clarity
  },
  reducers: {
    setPlans: (state, action) => {
      state.plans = action.payload; // Updated key to match initialState
    },
  },
});

export const { setPlans } = planSlice.actions;
export default planSlice.reducer;
